import HRWorkstation from "./HRWorkstation";
export default HRWorkstation;
